import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';

export default function NotFound() {
  return (
    <Layout>
      <div className="mx-auto flex min-h-[60vh] w-full flex-col items-center justify-center px-4 py-20 text-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-emotion-sad-line text-3xl" />
        </span>
        <h1 className="mt-6 font-heading text-5xl font-black text-foreground-950">404</h1>
        <p className="mt-3 text-lg font-semibold text-foreground-800">这个页面走丢了</p>
        <p className="mt-2 max-w-md text-sm text-foreground-500">
          您访问的页面可能已被移除或暂时不可用，不妨回到首页看看最新的热门视频吧。
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line text-lg" />
            返回首页
          </Link>
          <Link
            to="/search"
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-search-line text-lg" />
            搜索视频
          </Link>
        </div>
      </div>
    </Layout>
  );
}